import { BaseService, RequestType, ResponseType } from "@intech/react-service";

import { EmpresaEntidade } from "../entidades/EmpresaEntidade";

class Empresa extends BaseService {

  constructor() {
    super("Empresa");
  }

  BuscarTodas = () =>
    this.CreateRequest<Array<EmpresaEntidade>>(RequestType.GET, `BuscarTodas`);

}

export const EmpresaService = new Empresa();